export default __webpack_public_path__ + "static/media/close.c42e5073.svg";